var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-dialog',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('v-row',[_c('v-col',{staticClass:"center-all"},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t("errors.positionError"))+" ")])])],1)]},proxy:true}]),model:{value:(_vm.openModal),callback:function ($$v) {_vm.openModal=$$v},expression:"openModal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }